import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  required: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: '#159B78',
    fontSize: '16px'
  },
  notRequired: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: 'red',
    fontSize: '16px'
  },
  displayTitle: {
    fontSize: '14px'
  }
}));
